import { MutationHookOptions, gql } from '@apollo/client';

import { useEdeMutation, useEdeQueryName } from 'routes/marketplace-ede/context/edeQueryProvider';

const queryType = 'REVOKE_PERMISSION';

const useRevokePermissionMutation = (options: MutationHookOptions = {}) => {
  const queryName = useEdeQueryName(queryType);

  const REVOKE_PERMISSION_MUTATION = gql`
    mutation RevokePermission($appID: ID!) {
      ${queryName} (appID: $appID)
    }
  `;

  return useEdeMutation(REVOKE_PERMISSION_MUTATION, options);
};

export default useRevokePermissionMutation;
